//----------------------
// <auto-generated>
//     Split from WebApiController.ts
//     Regenerate with: node scripts/splitWebApiController.js
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming


import { PosClientBase, PosClientConfig, throwException } from './base';
import type { ActionOutboxEntityType, BulkActionType, BulkAdjustCostField, BulkChangePriceMode, BulkEditListingGroupSettingsInput, BulkEditLog, BulkEditLogPayload, BulkEditLogQuery, BulkEditPreview, BulkEditPreviewWithDetails, BulkEditProgress, BulkListingPriceCalculationResult, FileParameter, ImportFileResult, ListingPriceAdjustmentType, ListingQuery, Marketplace, MergeListingGroupInputList, PricingFloorCeilingAdjustmentType, PurchaseOrderQuery, SaleQuery, SalesFulfillerBackfillQuery, TicketBarcode, TicketBarcodeResponse, ValueTupleOfBulkEditPreviewAndDecimal, ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority, ValueTupleOfBulkEditPreviewAndGuid, ValueTupleOfBulkEditPreviewAndIDictionaryOfLongAndListOfInteger, ValueTupleOfBulkEditPreviewAndIListOfCommission, ValueTupleOfBulkEditPreviewAndIListOfListingNote, ValueTupleOfBulkEditPreviewAndISetOfMarketplaceAndISetOfMarketplace, ValueTupleOfBulkEditPreviewAndListingDetailsAutoPricingSectionUpdatesV2, ValueTupleOfBulkEditPreviewAndListingDetailsUpdateInput, ValueTupleOfBulkEditPreviewAndListingPricesUpdateInput, ValueTupleOfBulkEditPreviewAndNullableSaleCancellationReason, ValueTupleOfBulkEditPreviewAndPosFieldOfNullableGuid, ValueTupleOfBulkEditPreviewAndSaleInput, ValueTupleOfBulkEditPreviewAndString, ValueTupleOfBulkEditPreviewAndStringAndStringAndStringAndString, ValueTupleOfInt64OfAndListingPriceCalculationsInEventInput } from './types';


export interface IBulkEditListingClient {

    cancelBackgroundTask(updateKey: string | undefined): Promise<boolean>;

    bulkUpdateListingsPricesPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateListingsPricesByPercent(preview: BulkEditPreview, percent: number | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, adjustmentType: ListingPriceAdjustmentType | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateListingsPrices(preview: BulkEditPreview, priceChange: number | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, adjustmentType: ListingPriceAdjustmentType | null | undefined): Promise<BulkEditProgress>;

    bulkUpdatePriceFloorCeilingPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdatePriceFloor(preview: BulkEditPreview, amount: number | undefined, updateKey: string | undefined, isRelative: boolean | undefined, adjustmentType: PricingFloorCeilingAdjustmentType | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdatePriceCeiling(preview: BulkEditPreview, percentMarketPrice: number | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUngroupListingsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUngroupListings(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkRemovePredeliveryPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkRemovePredelivery(preview: BulkEditPreview, removeBarcodes: boolean | undefined, removePdfs: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateMarketplaceSeatingOverridesPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateMarketplaceSeatingOverrides(input: ValueTupleOfBulkEditPreviewAndListingDetailsUpdateInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<boolean>;

    bulkChangeEventPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkChangeEvent(preview: BulkEditPreview, posEventId: string | undefined, viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined, deallocateSales: boolean | null | undefined, reason: string | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateAutoPricingSettingsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateAutoPricingSettings(input: ValueTupleOfBulkEditPreviewAndListingDetailsUpdateInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateAutoPricingSettingsV2(input: ValueTupleOfBulkEditPreviewAndListingDetailsAutoPricingSectionUpdatesV2, viagogoEventId: number | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkGetListingPriceCalculationsInEvent(viagogoEventId: number | undefined, body: ValueTupleOfInt64OfAndListingPriceCalculationsInEventInput): Promise<BulkListingPriceCalculationResult>;

    bulkUpdateGeneralSettingsPreview(query: ListingQuery, hasPurchaseUpdates: boolean | undefined): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateGeneralSettings(input: ValueTupleOfBulkEditPreviewAndListingDetailsUpdateInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateMarketplacePrices(input: ValueTupleOfBulkEditPreviewAndListingPricesUpdateInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateMarketplacePricesPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkBroadcastListingsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkBroadcastListings(input: ValueTupleOfBulkEditPreviewAndISetOfMarketplaceAndISetOfMarketplace, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateAdminHoldPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateAdminHold(preview: BulkEditPreview, adminHoldExpirationDate: string | null | undefined, adminHoldNotes: string | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateTicketTypeRulesPreview(query: ListingQuery, updateSalesOfListings: boolean | undefined): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateTicketTypeRules(input: ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, updateSalesOfListings: boolean | undefined): Promise<BulkEditProgress>;

    bulkUpdateTagsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateTags(preview: BulkEditPreview, tagName: string | undefined, tagValue: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkRemoveTags(preview: BulkEditPreview, tagName: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkCreateListingGroups(input: MergeListingGroupInputList, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdatePurchaseCommissionsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdatePurchaseCommissions(input: ValueTupleOfBulkEditPreviewAndIListOfCommission, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkDeleteSeatSaversPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkDeleteSeatSavers(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateInternalNotesPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateInternalNotes(preview: BulkEditPreview, updateKey: string | undefined, isUpdate: boolean | undefined, searchString: string | null | undefined, replaceString: string | null | undefined, appendString: string | null | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateIsNoFulfillPreview(query: ListingQuery, updateSalesOfListings: boolean | undefined): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateIsNoFulfill(preview: BulkEditPreview, updateKey: string | undefined, isNoFulfill: boolean | undefined, updateSalesOfListings: boolean | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateDeliveryTypePreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateDeliveryType(input: ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateSeatTraitsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateSeatTraits(input: ValueTupleOfBulkEditPreviewAndIListOfListingNote, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, appendSeatTraits: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkWasteTicketsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkWasteTickets(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUnwasteTicketsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUnwasteTickets(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkResetMergedListingsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkResetMergedListings(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateBarcodesPreview(query: ListingQuery): Promise<{ [key: string]: TicketBarcodeResponse[]; }>;

    bulkUpdateBarcodes(allBarcodes: { [key: string]: TicketBarcode[]; }, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkMergeSelectedListingsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkMergeSelectedListings(preview: BulkEditPreview, excludeHeldListings: boolean | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkReturnTicketPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkReturnTicket(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    importSeatSaversFromFile(updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, file: FileParameter | null | undefined): Promise<ImportFileResult>;

    bulkSplitSelectedListingsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkSplitSelectedListings(input: ValueTupleOfBulkEditPreviewAndIDictionaryOfLongAndListOfInteger, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, retainSeatTraits: boolean | null | undefined): Promise<BulkEditProgress>;
}

export class BulkEditListingClient extends PosClientBase implements IBulkEditListingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    cancelBackgroundTask(updateKey: string | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/BulkEditListing/CancelBackgroundTask?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelBackgroundTask(_response);
        });
    }

    protected processCancelBackgroundTask(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    bulkUpdateListingsPricesPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateListingsPricesPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateListingsPricesPreview(_response);
        });
    }

    protected processBulkUpdateListingsPricesPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateListingsPricesByPercent(preview: BulkEditPreview, percent: number | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, adjustmentType: ListingPriceAdjustmentType | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateListingsPricesByPercent?";
        if (percent === null)
            throw new Error("The parameter 'percent' cannot be null.");
        else if (percent !== undefined)
            url_ += "percent=" + encodeURIComponent("" + percent) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        if (adjustmentType !== undefined && adjustmentType !== null)
            url_ += "adjustmentType=" + encodeURIComponent("" + adjustmentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateListingsPricesByPercent(_response);
        });
    }

    protected processBulkUpdateListingsPricesByPercent(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateListingsPrices(preview: BulkEditPreview, priceChange: number | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, adjustmentType: ListingPriceAdjustmentType | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateListingsPrices?";
        if (priceChange === null)
            throw new Error("The parameter 'priceChange' cannot be null.");
        else if (priceChange !== undefined)
            url_ += "priceChange=" + encodeURIComponent("" + priceChange) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        if (adjustmentType !== undefined && adjustmentType !== null)
            url_ += "adjustmentType=" + encodeURIComponent("" + adjustmentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateListingsPrices(_response);
        });
    }

    protected processBulkUpdateListingsPrices(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdatePriceFloorCeilingPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdatePriceFloorCeilingPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePriceFloorCeilingPreview(_response);
        });
    }

    protected processBulkUpdatePriceFloorCeilingPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdatePriceFloor(preview: BulkEditPreview, amount: number | undefined, updateKey: string | undefined, isRelative: boolean | undefined, adjustmentType: PricingFloorCeilingAdjustmentType | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdatePriceFloor?";
        if (amount === null)
            throw new Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (isRelative === null)
            throw new Error("The parameter 'isRelative' cannot be null.");
        else if (isRelative !== undefined)
            url_ += "isRelative=" + encodeURIComponent("" + isRelative) + "&";
        if (adjustmentType === null)
            throw new Error("The parameter 'adjustmentType' cannot be null.");
        else if (adjustmentType !== undefined)
            url_ += "adjustmentType=" + encodeURIComponent("" + adjustmentType) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePriceFloor(_response);
        });
    }

    protected processBulkUpdatePriceFloor(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdatePriceCeiling(preview: BulkEditPreview, percentMarketPrice: number | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdatePriceCeiling?";
        if (percentMarketPrice === null)
            throw new Error("The parameter 'percentMarketPrice' cannot be null.");
        else if (percentMarketPrice !== undefined)
            url_ += "percentMarketPrice=" + encodeURIComponent("" + percentMarketPrice) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePriceCeiling(_response);
        });
    }

    protected processBulkUpdatePriceCeiling(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUngroupListingsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUngroupListingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUngroupListingsPreview(_response);
        });
    }

    protected processBulkUngroupListingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUngroupListings(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUngroupListings?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUngroupListings(_response);
        });
    }

    protected processBulkUngroupListings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkRemovePredeliveryPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkRemovePredeliveryPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkRemovePredeliveryPreview(_response);
        });
    }

    protected processBulkRemovePredeliveryPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkRemovePredelivery(preview: BulkEditPreview, removeBarcodes: boolean | undefined, removePdfs: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkRemovePredelivery?";
        if (removeBarcodes === null)
            throw new Error("The parameter 'removeBarcodes' cannot be null.");
        else if (removeBarcodes !== undefined)
            url_ += "removeBarcodes=" + encodeURIComponent("" + removeBarcodes) + "&";
        if (removePdfs === null)
            throw new Error("The parameter 'removePdfs' cannot be null.");
        else if (removePdfs !== undefined)
            url_ += "removePdfs=" + encodeURIComponent("" + removePdfs) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkRemovePredelivery(_response);
        });
    }

    protected processBulkRemovePredelivery(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateMarketplaceSeatingOverridesPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateMarketplaceSeatingOverridesPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateMarketplaceSeatingOverridesPreview(_response);
        });
    }

    protected processBulkUpdateMarketplaceSeatingOverridesPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateMarketplaceSeatingOverrides(input: ValueTupleOfBulkEditPreviewAndListingDetailsUpdateInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateMarketplaceSeatingOverrides?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateMarketplaceSeatingOverrides(_response);
        });
    }

    protected processBulkUpdateMarketplaceSeatingOverrides(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    bulkChangeEventPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkChangeEventPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkChangeEventPreview(_response);
        });
    }

    protected processBulkChangeEventPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkChangeEvent(preview: BulkEditPreview, posEventId: string | undefined, viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined, deallocateSales: boolean | null | undefined, reason: string | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkChangeEvent?";
        if (posEventId === null)
            throw new Error("The parameter 'posEventId' cannot be null.");
        else if (posEventId !== undefined)
            url_ += "posEventId=" + encodeURIComponent("" + posEventId) + "&";
        if (viagogoEventId !== undefined && viagogoEventId !== null)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (eventMappingId !== undefined && eventMappingId !== null)
            url_ += "eventMappingId=" + encodeURIComponent("" + eventMappingId) + "&";
        if (deallocateSales !== undefined && deallocateSales !== null)
            url_ += "deallocateSales=" + encodeURIComponent("" + deallocateSales) + "&";
        if (reason !== undefined && reason !== null)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkChangeEvent(_response);
        });
    }

    protected processBulkChangeEvent(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateAutoPricingSettingsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateAutoPricingSettingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateAutoPricingSettingsPreview(_response);
        });
    }

    protected processBulkUpdateAutoPricingSettingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateAutoPricingSettings(input: ValueTupleOfBulkEditPreviewAndListingDetailsUpdateInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateAutoPricingSettings?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateAutoPricingSettings(_response);
        });
    }

    protected processBulkUpdateAutoPricingSettings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateAutoPricingSettingsV2(input: ValueTupleOfBulkEditPreviewAndListingDetailsAutoPricingSectionUpdatesV2, viagogoEventId: number | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateAutoPricingSettingsV2?";
        if (viagogoEventId !== undefined && viagogoEventId !== null)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateAutoPricingSettingsV2(_response);
        });
    }

    protected processBulkUpdateAutoPricingSettingsV2(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkGetListingPriceCalculationsInEvent(viagogoEventId: number | undefined, body: ValueTupleOfInt64OfAndListingPriceCalculationsInEventInput, signal?: AbortSignal | undefined): Promise<BulkListingPriceCalculationResult> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkGetListingPriceCalculationsInEvent?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkGetListingPriceCalculationsInEvent(_response);
        });
    }

    protected processBulkGetListingPriceCalculationsInEvent(response: Response): Promise<BulkListingPriceCalculationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkListingPriceCalculationResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkListingPriceCalculationResult>(null as any);
    }

    bulkUpdateGeneralSettingsPreview(query: ListingQuery, hasPurchaseUpdates: boolean | undefined, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateGeneralSettingsPreview?";
        if (hasPurchaseUpdates === null)
            throw new Error("The parameter 'hasPurchaseUpdates' cannot be null.");
        else if (hasPurchaseUpdates !== undefined)
            url_ += "hasPurchaseUpdates=" + encodeURIComponent("" + hasPurchaseUpdates) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateGeneralSettingsPreview(_response);
        });
    }

    protected processBulkUpdateGeneralSettingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateGeneralSettings(input: ValueTupleOfBulkEditPreviewAndListingDetailsUpdateInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateGeneralSettings?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateGeneralSettings(_response);
        });
    }

    protected processBulkUpdateGeneralSettings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateMarketplacePrices(input: ValueTupleOfBulkEditPreviewAndListingPricesUpdateInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateMarketplacePrices?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateMarketplacePrices(_response);
        });
    }

    protected processBulkUpdateMarketplacePrices(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateMarketplacePricesPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateMarketplacePricesPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateMarketplacePricesPreview(_response);
        });
    }

    protected processBulkUpdateMarketplacePricesPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkBroadcastListingsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkBroadcastListingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkBroadcastListingsPreview(_response);
        });
    }

    protected processBulkBroadcastListingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkBroadcastListings(input: ValueTupleOfBulkEditPreviewAndISetOfMarketplaceAndISetOfMarketplace, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkBroadcastListings?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkBroadcastListings(_response);
        });
    }

    protected processBulkBroadcastListings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateAdminHoldPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateAdminHoldPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateAdminHoldPreview(_response);
        });
    }

    protected processBulkUpdateAdminHoldPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateAdminHold(preview: BulkEditPreview, adminHoldExpirationDate: string | null | undefined, adminHoldNotes: string | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateAdminHold?";
        if (adminHoldExpirationDate !== undefined && adminHoldExpirationDate !== null)
            url_ += "adminHoldExpirationDate=" + encodeURIComponent("" + adminHoldExpirationDate) + "&";
        if (adminHoldNotes !== undefined && adminHoldNotes !== null)
            url_ += "adminHoldNotes=" + encodeURIComponent("" + adminHoldNotes) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateAdminHold(_response);
        });
    }

    protected processBulkUpdateAdminHold(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateTicketTypeRulesPreview(query: ListingQuery, updateSalesOfListings: boolean | undefined, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateTicketTypeRulesPreview?";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateTicketTypeRulesPreview(_response);
        });
    }

    protected processBulkUpdateTicketTypeRulesPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateTicketTypeRules(input: ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, updateSalesOfListings: boolean | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateTicketTypeRules?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateTicketTypeRules(_response);
        });
    }

    protected processBulkUpdateTicketTypeRules(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateTagsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateTagsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateTagsPreview(_response);
        });
    }

    protected processBulkUpdateTagsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateTags(preview: BulkEditPreview, tagName: string | undefined, tagValue: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateTags?";
        if (tagName === null)
            throw new Error("The parameter 'tagName' cannot be null.");
        else if (tagName !== undefined)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        if (tagValue === null)
            throw new Error("The parameter 'tagValue' cannot be null.");
        else if (tagValue !== undefined)
            url_ += "tagValue=" + encodeURIComponent("" + tagValue) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateTags(_response);
        });
    }

    protected processBulkUpdateTags(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkRemoveTags(preview: BulkEditPreview, tagName: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkRemoveTags?";
        if (tagName === null)
            throw new Error("The parameter 'tagName' cannot be null.");
        else if (tagName !== undefined)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkRemoveTags(_response);
        });
    }

    protected processBulkRemoveTags(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkCreateListingGroups(input: MergeListingGroupInputList, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkCreateListingGroups?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkCreateListingGroups(_response);
        });
    }

    protected processBulkCreateListingGroups(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdatePurchaseCommissionsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdatePurchaseCommissionsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePurchaseCommissionsPreview(_response);
        });
    }

    protected processBulkUpdatePurchaseCommissionsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdatePurchaseCommissions(input: ValueTupleOfBulkEditPreviewAndIListOfCommission, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdatePurchaseCommissions?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePurchaseCommissions(_response);
        });
    }

    protected processBulkUpdatePurchaseCommissions(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkDeleteSeatSaversPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkDeleteSeatSaversPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeleteSeatSaversPreview(_response);
        });
    }

    protected processBulkDeleteSeatSaversPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkDeleteSeatSavers(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkDeleteSeatSavers?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeleteSeatSavers(_response);
        });
    }

    protected processBulkDeleteSeatSavers(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateInternalNotesPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateInternalNotesPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateInternalNotesPreview(_response);
        });
    }

    protected processBulkUpdateInternalNotesPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateInternalNotes(preview: BulkEditPreview, updateKey: string | undefined, isUpdate: boolean | undefined, searchString: string | null | undefined, replaceString: string | null | undefined, appendString: string | null | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateInternalNotes?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (isUpdate === null)
            throw new Error("The parameter 'isUpdate' cannot be null.");
        else if (isUpdate !== undefined)
            url_ += "isUpdate=" + encodeURIComponent("" + isUpdate) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        if (replaceString !== undefined && replaceString !== null)
            url_ += "replaceString=" + encodeURIComponent("" + replaceString) + "&";
        if (appendString !== undefined && appendString !== null)
            url_ += "appendString=" + encodeURIComponent("" + appendString) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateInternalNotes(_response);
        });
    }

    protected processBulkUpdateInternalNotes(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateIsNoFulfillPreview(query: ListingQuery, updateSalesOfListings: boolean | undefined, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateIsNoFulfillPreview?";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateIsNoFulfillPreview(_response);
        });
    }

    protected processBulkUpdateIsNoFulfillPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateIsNoFulfill(preview: BulkEditPreview, updateKey: string | undefined, isNoFulfill: boolean | undefined, updateSalesOfListings: boolean | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateIsNoFulfill?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (isNoFulfill === null)
            throw new Error("The parameter 'isNoFulfill' cannot be null.");
        else if (isNoFulfill !== undefined)
            url_ += "isNoFulfill=" + encodeURIComponent("" + isNoFulfill) + "&";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateIsNoFulfill(_response);
        });
    }

    protected processBulkUpdateIsNoFulfill(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateDeliveryTypePreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateDeliveryTypePreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateDeliveryTypePreview(_response);
        });
    }

    protected processBulkUpdateDeliveryTypePreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateDeliveryType(input: ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateDeliveryType?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateDeliveryType(_response);
        });
    }

    protected processBulkUpdateDeliveryType(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateSeatTraitsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateSeatTraitsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateSeatTraitsPreview(_response);
        });
    }

    protected processBulkUpdateSeatTraitsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateSeatTraits(input: ValueTupleOfBulkEditPreviewAndIListOfListingNote, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, appendSeatTraits: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateSeatTraits?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        if (appendSeatTraits !== undefined && appendSeatTraits !== null)
            url_ += "appendSeatTraits=" + encodeURIComponent("" + appendSeatTraits) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateSeatTraits(_response);
        });
    }

    protected processBulkUpdateSeatTraits(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkWasteTicketsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkWasteTicketsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkWasteTicketsPreview(_response);
        });
    }

    protected processBulkWasteTicketsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkWasteTickets(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkWasteTickets?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkWasteTickets(_response);
        });
    }

    protected processBulkWasteTickets(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUnwasteTicketsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUnwasteTicketsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUnwasteTicketsPreview(_response);
        });
    }

    protected processBulkUnwasteTicketsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUnwasteTickets(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUnwasteTickets?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUnwasteTickets(_response);
        });
    }

    protected processBulkUnwasteTickets(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkResetMergedListingsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkResetMergedListingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkResetMergedListingsPreview(_response);
        });
    }

    protected processBulkResetMergedListingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkResetMergedListings(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkResetMergedListings?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkResetMergedListings(_response);
        });
    }

    protected processBulkResetMergedListings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateBarcodesPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<{ [key: string]: TicketBarcodeResponse[]; }> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateBarcodesPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateBarcodesPreview(_response);
        });
    }

    protected processBulkUpdateBarcodesPreview(response: Response): Promise<{ [key: string]: TicketBarcodeResponse[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: TicketBarcodeResponse[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: TicketBarcodeResponse[]; }>(null as any);
    }

    bulkUpdateBarcodes(allBarcodes: { [key: string]: TicketBarcode[]; }, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateBarcodes?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(allBarcodes);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateBarcodes(_response);
        });
    }

    protected processBulkUpdateBarcodes(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkMergeSelectedListingsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkMergeSelectedListingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkMergeSelectedListingsPreview(_response);
        });
    }

    protected processBulkMergeSelectedListingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkMergeSelectedListings(preview: BulkEditPreview, excludeHeldListings: boolean | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkMergeSelectedListings?";
        if (excludeHeldListings !== undefined && excludeHeldListings !== null)
            url_ += "excludeHeldListings=" + encodeURIComponent("" + excludeHeldListings) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkMergeSelectedListings(_response);
        });
    }

    protected processBulkMergeSelectedListings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkReturnTicketPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkReturnTicketPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkReturnTicketPreview(_response);
        });
    }

    protected processBulkReturnTicketPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkReturnTicket(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkReturnTicket?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkReturnTicket(_response);
        });
    }

    protected processBulkReturnTicket(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    importSeatSaversFromFile(updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, file: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<ImportFileResult> {
        let url_ = this.baseUrl + "/api/BulkEditListing/ImportSeatSaversFromFile?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImportSeatSaversFromFile(_response);
        });
    }

    protected processImportSeatSaversFromFile(response: Response): Promise<ImportFileResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportFileResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportFileResult>(null as any);
    }

    bulkSplitSelectedListingsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkSplitSelectedListingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkSplitSelectedListingsPreview(_response);
        });
    }

    protected processBulkSplitSelectedListingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkSplitSelectedListings(input: ValueTupleOfBulkEditPreviewAndIDictionaryOfLongAndListOfInteger, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, retainSeatTraits: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkSplitSelectedListings?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        if (retainSeatTraits !== undefined && retainSeatTraits !== null)
            url_ += "retainSeatTraits=" + encodeURIComponent("" + retainSeatTraits) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkSplitSelectedListings(_response);
        });
    }

    protected processBulkSplitSelectedListings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }
}
export interface IBulkEditListingGroupClient {

    cancelBackgroundTask(updateKey: string | undefined): Promise<boolean>;

    bulkEditListingsGroupSettingsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkEditListingGroupSettings(input: BulkEditListingGroupSettingsInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;
}

export class BulkEditListingGroupClient extends PosClientBase implements IBulkEditListingGroupClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    cancelBackgroundTask(updateKey: string | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/BulkEditListingGroup/CancelBackgroundTask?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelBackgroundTask(_response);
        });
    }

    protected processCancelBackgroundTask(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    bulkEditListingsGroupSettingsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListingGroup/BulkEditListingsGroupSettingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkEditListingsGroupSettingsPreview(_response);
        });
    }

    protected processBulkEditListingsGroupSettingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkEditListingGroupSettings(input: BulkEditListingGroupSettingsInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListingGroup/BulkEditListingGroupSettings?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkEditListingGroupSettings(_response);
        });
    }

    protected processBulkEditListingGroupSettings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }
}
export interface IBulkEditLogClient {

    getBulkEditLogByFilter(query: BulkEditLogQuery): Promise<BulkEditLog[]>;

    getBulkEditLogPayload(entityType: ActionOutboxEntityType | undefined, bulkActionType: BulkActionType | undefined, bulkProcessingId: string | undefined): Promise<BulkEditLogPayload>;
}

export class BulkEditLogClient extends PosClientBase implements IBulkEditLogClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getBulkEditLogByFilter(query: BulkEditLogQuery, signal?: AbortSignal | undefined): Promise<BulkEditLog[]> {
        let url_ = this.baseUrl + "/api/BulkEditLog/GetBulkEditLogByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBulkEditLogByFilter(_response);
        });
    }

    protected processGetBulkEditLogByFilter(response: Response): Promise<BulkEditLog[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditLog[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditLog[]>(null as any);
    }

    getBulkEditLogPayload(entityType: ActionOutboxEntityType | undefined, bulkActionType: BulkActionType | undefined, bulkProcessingId: string | undefined, signal?: AbortSignal | undefined): Promise<BulkEditLogPayload> {
        let url_ = this.baseUrl + "/api/BulkEditLog/GetBulkEditLogPayload?";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        if (bulkActionType === null)
            throw new Error("The parameter 'bulkActionType' cannot be null.");
        else if (bulkActionType !== undefined)
            url_ += "bulkActionType=" + encodeURIComponent("" + bulkActionType) + "&";
        if (bulkProcessingId === null)
            throw new Error("The parameter 'bulkProcessingId' cannot be null.");
        else if (bulkProcessingId !== undefined)
            url_ += "bulkProcessingId=" + encodeURIComponent("" + bulkProcessingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBulkEditLogPayload(_response);
        });
    }

    protected processGetBulkEditLogPayload(response: Response): Promise<BulkEditLogPayload> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditLogPayload;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditLogPayload>(null as any);
    }
}
export interface IBulkEditPurchaseClient {

    cancelBackgroundTask(updateKey: string | undefined): Promise<boolean>;

    bulkUpdateGeneralSettingsPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateGeneralSettings(input: ValueTupleOfBulkEditPreviewAndPosFieldOfNullableGuid, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateCurrencyCodePreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateCurrencyCode(input: ValueTupleOfBulkEditPreviewAndString, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkDeletePurchaseOrderPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkVoidPurchaseOrder(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkCancelPurchaseOrder(input: ValueTupleOfBulkEditPreviewAndNullableSaleCancellationReason, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, rejectSale: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdatePurchaseCommissionsPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdatePurchaseCommissions(input: ValueTupleOfBulkEditPreviewAndIListOfCommission, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateTagsPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateTags(preview: BulkEditPreview, tagName: string | undefined, tagValue: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkRemoveTags(preview: BulkEditPreview, tagName: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateInternalNotesPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateInternalNotes(preview: BulkEditPreview, updateKey: string | undefined, isUpdate: boolean | undefined, searchString: string | null | undefined, replaceString: string | null | undefined, appendString: string | null | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkAdjustFxRatePreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkAdjustFxRate(preview: BulkEditPreview, updateKey: string | undefined, conversionRate: number | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkConvertPurchasePaymentPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkConvertPurchasePayment(preview: BulkEditPreview, updateKey: string | undefined, fromCurrencyCode: string | undefined, toCurrencyCode: string | undefined, conversionRate: number | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateDeliveryTypePreview(query: PurchaseOrderQuery, updateSalesOfListings: boolean | undefined): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateDeliveryType(input: ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority, updateSalesOfListings: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkBackfillDeliverySettingsPreview(query: PurchaseOrderQuery, updateSalesOfListings: boolean | undefined, applyToAllEvents: boolean | undefined): Promise<BulkEditPreviewWithDetails>;

    bulkBackfillDeliverySettings(preview: BulkEditPreview, updateSalesOfListings: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkBackfillDeliverySettingsListingOnly(preview: BulkEditPreview, updateSalesOfListings: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateSeatTraitsPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateSeatTraits(input: ValueTupleOfBulkEditPreviewAndIListOfListingNote, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, appendSeatTraits: boolean | null | undefined): Promise<BulkEditProgress>;

    importPurchaseFromFile(updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, file: FileParameter | null | undefined): Promise<ImportFileResult>;

    bulkMarkPurchaseAsPaidPreview(input: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkMarkPurchaseAsPaid(input: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkAdjustCostPreview(input: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkAdjustCost(input: BulkEditPreview, changeMode: BulkChangePriceMode | undefined, targetField: BulkAdjustCostField | undefined, percent: number | null | undefined, absoluteAmount: number | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;
}

export class BulkEditPurchaseClient extends PosClientBase implements IBulkEditPurchaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    cancelBackgroundTask(updateKey: string | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/CancelBackgroundTask?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelBackgroundTask(_response);
        });
    }

    protected processCancelBackgroundTask(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    bulkUpdateGeneralSettingsPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateGeneralSettingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateGeneralSettingsPreview(_response);
        });
    }

    protected processBulkUpdateGeneralSettingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateGeneralSettings(input: ValueTupleOfBulkEditPreviewAndPosFieldOfNullableGuid, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateGeneralSettings?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateGeneralSettings(_response);
        });
    }

    protected processBulkUpdateGeneralSettings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateCurrencyCodePreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateCurrencyCodePreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateCurrencyCodePreview(_response);
        });
    }

    protected processBulkUpdateCurrencyCodePreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateCurrencyCode(input: ValueTupleOfBulkEditPreviewAndString, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateCurrencyCode?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateCurrencyCode(_response);
        });
    }

    protected processBulkUpdateCurrencyCode(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkDeletePurchaseOrderPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkDeletePurchaseOrderPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeletePurchaseOrderPreview(_response);
        });
    }

    protected processBulkDeletePurchaseOrderPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkVoidPurchaseOrder(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkVoidPurchaseOrder?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkVoidPurchaseOrder(_response);
        });
    }

    protected processBulkVoidPurchaseOrder(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkCancelPurchaseOrder(input: ValueTupleOfBulkEditPreviewAndNullableSaleCancellationReason, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, rejectSale: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkCancelPurchaseOrder?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        if (rejectSale !== undefined && rejectSale !== null)
            url_ += "rejectSale=" + encodeURIComponent("" + rejectSale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkCancelPurchaseOrder(_response);
        });
    }

    protected processBulkCancelPurchaseOrder(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdatePurchaseCommissionsPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdatePurchaseCommissionsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePurchaseCommissionsPreview(_response);
        });
    }

    protected processBulkUpdatePurchaseCommissionsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdatePurchaseCommissions(input: ValueTupleOfBulkEditPreviewAndIListOfCommission, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdatePurchaseCommissions?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePurchaseCommissions(_response);
        });
    }

    protected processBulkUpdatePurchaseCommissions(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateTagsPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateTagsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateTagsPreview(_response);
        });
    }

    protected processBulkUpdateTagsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateTags(preview: BulkEditPreview, tagName: string | undefined, tagValue: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateTags?";
        if (tagName === null)
            throw new Error("The parameter 'tagName' cannot be null.");
        else if (tagName !== undefined)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        if (tagValue === null)
            throw new Error("The parameter 'tagValue' cannot be null.");
        else if (tagValue !== undefined)
            url_ += "tagValue=" + encodeURIComponent("" + tagValue) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateTags(_response);
        });
    }

    protected processBulkUpdateTags(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkRemoveTags(preview: BulkEditPreview, tagName: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkRemoveTags?";
        if (tagName === null)
            throw new Error("The parameter 'tagName' cannot be null.");
        else if (tagName !== undefined)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkRemoveTags(_response);
        });
    }

    protected processBulkRemoveTags(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateInternalNotesPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateInternalNotesPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateInternalNotesPreview(_response);
        });
    }

    protected processBulkUpdateInternalNotesPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateInternalNotes(preview: BulkEditPreview, updateKey: string | undefined, isUpdate: boolean | undefined, searchString: string | null | undefined, replaceString: string | null | undefined, appendString: string | null | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateInternalNotes?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (isUpdate === null)
            throw new Error("The parameter 'isUpdate' cannot be null.");
        else if (isUpdate !== undefined)
            url_ += "isUpdate=" + encodeURIComponent("" + isUpdate) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        if (replaceString !== undefined && replaceString !== null)
            url_ += "replaceString=" + encodeURIComponent("" + replaceString) + "&";
        if (appendString !== undefined && appendString !== null)
            url_ += "appendString=" + encodeURIComponent("" + appendString) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateInternalNotes(_response);
        });
    }

    protected processBulkUpdateInternalNotes(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkAdjustFxRatePreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkAdjustFxRatePreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkAdjustFxRatePreview(_response);
        });
    }

    protected processBulkAdjustFxRatePreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkAdjustFxRate(preview: BulkEditPreview, updateKey: string | undefined, conversionRate: number | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkAdjustFxRate?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (conversionRate === null)
            throw new Error("The parameter 'conversionRate' cannot be null.");
        else if (conversionRate !== undefined)
            url_ += "conversionRate=" + encodeURIComponent("" + conversionRate) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkAdjustFxRate(_response);
        });
    }

    protected processBulkAdjustFxRate(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkConvertPurchasePaymentPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkConvertPurchasePaymentPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkConvertPurchasePaymentPreview(_response);
        });
    }

    protected processBulkConvertPurchasePaymentPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkConvertPurchasePayment(preview: BulkEditPreview, updateKey: string | undefined, fromCurrencyCode: string | undefined, toCurrencyCode: string | undefined, conversionRate: number | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkConvertPurchasePayment?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (fromCurrencyCode === null)
            throw new Error("The parameter 'fromCurrencyCode' cannot be null.");
        else if (fromCurrencyCode !== undefined)
            url_ += "fromCurrencyCode=" + encodeURIComponent("" + fromCurrencyCode) + "&";
        if (toCurrencyCode === null)
            throw new Error("The parameter 'toCurrencyCode' cannot be null.");
        else if (toCurrencyCode !== undefined)
            url_ += "toCurrencyCode=" + encodeURIComponent("" + toCurrencyCode) + "&";
        if (conversionRate === null)
            throw new Error("The parameter 'conversionRate' cannot be null.");
        else if (conversionRate !== undefined)
            url_ += "conversionRate=" + encodeURIComponent("" + conversionRate) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkConvertPurchasePayment(_response);
        });
    }

    protected processBulkConvertPurchasePayment(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateDeliveryTypePreview(query: PurchaseOrderQuery, updateSalesOfListings: boolean | undefined, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateDeliveryTypePreview?";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateDeliveryTypePreview(_response);
        });
    }

    protected processBulkUpdateDeliveryTypePreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateDeliveryType(input: ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority, updateSalesOfListings: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateDeliveryType?";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateDeliveryType(_response);
        });
    }

    protected processBulkUpdateDeliveryType(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkBackfillDeliverySettingsPreview(query: PurchaseOrderQuery, updateSalesOfListings: boolean | undefined, applyToAllEvents: boolean | undefined, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkBackfillDeliverySettingsPreview?";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        if (applyToAllEvents === null)
            throw new Error("The parameter 'applyToAllEvents' cannot be null.");
        else if (applyToAllEvents !== undefined)
            url_ += "applyToAllEvents=" + encodeURIComponent("" + applyToAllEvents) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkBackfillDeliverySettingsPreview(_response);
        });
    }

    protected processBulkBackfillDeliverySettingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkBackfillDeliverySettings(preview: BulkEditPreview, updateSalesOfListings: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkBackfillDeliverySettings?";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkBackfillDeliverySettings(_response);
        });
    }

    protected processBulkBackfillDeliverySettings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkBackfillDeliverySettingsListingOnly(preview: BulkEditPreview, updateSalesOfListings: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkBackfillDeliverySettingsListingOnly?";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkBackfillDeliverySettingsListingOnly(_response);
        });
    }

    protected processBulkBackfillDeliverySettingsListingOnly(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateSeatTraitsPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateSeatTraitsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateSeatTraitsPreview(_response);
        });
    }

    protected processBulkUpdateSeatTraitsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateSeatTraits(input: ValueTupleOfBulkEditPreviewAndIListOfListingNote, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, appendSeatTraits: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateSeatTraits?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        if (appendSeatTraits !== undefined && appendSeatTraits !== null)
            url_ += "appendSeatTraits=" + encodeURIComponent("" + appendSeatTraits) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateSeatTraits(_response);
        });
    }

    protected processBulkUpdateSeatTraits(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    importPurchaseFromFile(updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, file: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<ImportFileResult> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/ImportPurchaseFromFile?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImportPurchaseFromFile(_response);
        });
    }

    protected processImportPurchaseFromFile(response: Response): Promise<ImportFileResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportFileResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportFileResult>(null as any);
    }

    bulkMarkPurchaseAsPaidPreview(input: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkMarkPurchaseAsPaidPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkMarkPurchaseAsPaidPreview(_response);
        });
    }

    protected processBulkMarkPurchaseAsPaidPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkMarkPurchaseAsPaid(input: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkMarkPurchaseAsPaid?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkMarkPurchaseAsPaid(_response);
        });
    }

    protected processBulkMarkPurchaseAsPaid(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkAdjustCostPreview(input: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkAdjustCostPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkAdjustCostPreview(_response);
        });
    }

    protected processBulkAdjustCostPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkAdjustCost(input: BulkEditPreview, changeMode: BulkChangePriceMode | undefined, targetField: BulkAdjustCostField | undefined, percent: number | null | undefined, absoluteAmount: number | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkAdjustCost?";
        if (changeMode === null)
            throw new Error("The parameter 'changeMode' cannot be null.");
        else if (changeMode !== undefined)
            url_ += "changeMode=" + encodeURIComponent("" + changeMode) + "&";
        if (targetField === null)
            throw new Error("The parameter 'targetField' cannot be null.");
        else if (targetField !== undefined)
            url_ += "targetField=" + encodeURIComponent("" + targetField) + "&";
        if (percent !== undefined && percent !== null)
            url_ += "percent=" + encodeURIComponent("" + percent) + "&";
        if (absoluteAmount !== undefined && absoluteAmount !== null)
            url_ += "absoluteAmount=" + encodeURIComponent("" + absoluteAmount) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkAdjustCost(_response);
        });
    }

    protected processBulkAdjustCost(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }
}
export interface IBulkEditSaleClient {

    cancelBackgroundTask(updateKey: string | undefined): Promise<boolean>;

    bulkUpdateGeneralSettingsPreview(query: SaleQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateGeneralSettings(input: ValueTupleOfBulkEditPreviewAndSaleInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdatePurchaseCommissionsPreview(query: SaleQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdatePurchaseCommissions(input: ValueTupleOfBulkEditPreviewAndIListOfCommission, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdatePaymentFieldsPreview(query: SaleQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdatePaymentFields(preview: BulkEditPreview, paymentReceived: boolean | null | undefined, paymentReferenceId: string | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateTagsPreview(query: SaleQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateTags(preview: BulkEditPreview, tagName: string | undefined, tagValue: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkRemoveTags(preview: BulkEditPreview, tagName: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateInternalNotesPreview(query: SaleQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateInternalNotes(preview: BulkEditPreview, updateKey: string | undefined, isUpdate: boolean | undefined, searchString: string | null | undefined, replaceString: string | null | undefined, appendString: string | null | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateIsNoFulfillPreview(query: SaleQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateIsNoFulfill(preview: BulkEditPreview, updateKey: string | undefined, isNoFulfill: boolean | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateMarkAsFulfilledPreview(query: SaleQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateMarkAsFulfilled(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkMarkSaleAsPaidPreview(query: SaleQuery): Promise<BulkEditPreviewWithDetails>;

    bulkMarkSaleAsPaid(preview: BulkEditPreview, paymentRefId: string | undefined, paymentDate: string | undefined, marketplace: Marketplace | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkDeallocateCancelSalePreview(query: SaleQuery): Promise<BulkEditPreviewWithDetails>;

    bulkDeallocateCancelSale(input: ValueTupleOfBulkEditPreviewAndNullableSaleCancellationReason, deallocateOnly: boolean | undefined, removeArtifacts: boolean | null | undefined, adminHold: boolean | null | undefined, keepAllocatedTickets: boolean | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateBarcodesPreview(query: SaleQuery): Promise<{ [key: string]: TicketBarcodeResponse[]; }>;

    bulkUpdateBarcodes(allBarcodes: { [key: string]: TicketBarcode[]; }, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkBackfillSalesFulfillerPreview(query: SalesFulfillerBackfillQuery): Promise<BulkEditPreviewWithDetails>;

    bulkBackfillSalesFulfiller(input: ValueTupleOfBulkEditPreviewAndGuid, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;
}

export class BulkEditSaleClient extends PosClientBase implements IBulkEditSaleClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    cancelBackgroundTask(updateKey: string | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/BulkEditSale/CancelBackgroundTask?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelBackgroundTask(_response);
        });
    }

    protected processCancelBackgroundTask(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    bulkUpdateGeneralSettingsPreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateGeneralSettingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateGeneralSettingsPreview(_response);
        });
    }

    protected processBulkUpdateGeneralSettingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateGeneralSettings(input: ValueTupleOfBulkEditPreviewAndSaleInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateGeneralSettings?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateGeneralSettings(_response);
        });
    }

    protected processBulkUpdateGeneralSettings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdatePurchaseCommissionsPreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdatePurchaseCommissionsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePurchaseCommissionsPreview(_response);
        });
    }

    protected processBulkUpdatePurchaseCommissionsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdatePurchaseCommissions(input: ValueTupleOfBulkEditPreviewAndIListOfCommission, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdatePurchaseCommissions?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePurchaseCommissions(_response);
        });
    }

    protected processBulkUpdatePurchaseCommissions(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdatePaymentFieldsPreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdatePaymentFieldsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePaymentFieldsPreview(_response);
        });
    }

    protected processBulkUpdatePaymentFieldsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdatePaymentFields(preview: BulkEditPreview, paymentReceived: boolean | null | undefined, paymentReferenceId: string | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdatePaymentFields?";
        if (paymentReceived !== undefined && paymentReceived !== null)
            url_ += "paymentReceived=" + encodeURIComponent("" + paymentReceived) + "&";
        if (paymentReferenceId !== undefined && paymentReferenceId !== null)
            url_ += "paymentReferenceId=" + encodeURIComponent("" + paymentReferenceId) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePaymentFields(_response);
        });
    }

    protected processBulkUpdatePaymentFields(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateTagsPreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateTagsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateTagsPreview(_response);
        });
    }

    protected processBulkUpdateTagsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateTags(preview: BulkEditPreview, tagName: string | undefined, tagValue: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateTags?";
        if (tagName === null)
            throw new Error("The parameter 'tagName' cannot be null.");
        else if (tagName !== undefined)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        if (tagValue === null)
            throw new Error("The parameter 'tagValue' cannot be null.");
        else if (tagValue !== undefined)
            url_ += "tagValue=" + encodeURIComponent("" + tagValue) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateTags(_response);
        });
    }

    protected processBulkUpdateTags(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkRemoveTags(preview: BulkEditPreview, tagName: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkRemoveTags?";
        if (tagName === null)
            throw new Error("The parameter 'tagName' cannot be null.");
        else if (tagName !== undefined)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkRemoveTags(_response);
        });
    }

    protected processBulkRemoveTags(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateInternalNotesPreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateInternalNotesPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateInternalNotesPreview(_response);
        });
    }

    protected processBulkUpdateInternalNotesPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateInternalNotes(preview: BulkEditPreview, updateKey: string | undefined, isUpdate: boolean | undefined, searchString: string | null | undefined, replaceString: string | null | undefined, appendString: string | null | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateInternalNotes?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (isUpdate === null)
            throw new Error("The parameter 'isUpdate' cannot be null.");
        else if (isUpdate !== undefined)
            url_ += "isUpdate=" + encodeURIComponent("" + isUpdate) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        if (replaceString !== undefined && replaceString !== null)
            url_ += "replaceString=" + encodeURIComponent("" + replaceString) + "&";
        if (appendString !== undefined && appendString !== null)
            url_ += "appendString=" + encodeURIComponent("" + appendString) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateInternalNotes(_response);
        });
    }

    protected processBulkUpdateInternalNotes(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateIsNoFulfillPreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateIsNoFulfillPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateIsNoFulfillPreview(_response);
        });
    }

    protected processBulkUpdateIsNoFulfillPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateIsNoFulfill(preview: BulkEditPreview, updateKey: string | undefined, isNoFulfill: boolean | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateIsNoFulfill?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (isNoFulfill === null)
            throw new Error("The parameter 'isNoFulfill' cannot be null.");
        else if (isNoFulfill !== undefined)
            url_ += "isNoFulfill=" + encodeURIComponent("" + isNoFulfill) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateIsNoFulfill(_response);
        });
    }

    protected processBulkUpdateIsNoFulfill(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateMarkAsFulfilledPreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateMarkAsFulfilledPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateMarkAsFulfilledPreview(_response);
        });
    }

    protected processBulkUpdateMarkAsFulfilledPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateMarkAsFulfilled(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateMarkAsFulfilled?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateMarkAsFulfilled(_response);
        });
    }

    protected processBulkUpdateMarkAsFulfilled(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkMarkSaleAsPaidPreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkMarkSaleAsPaidPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkMarkSaleAsPaidPreview(_response);
        });
    }

    protected processBulkMarkSaleAsPaidPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkMarkSaleAsPaid(preview: BulkEditPreview, paymentRefId: string | undefined, paymentDate: string | undefined, marketplace: Marketplace | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkMarkSaleAsPaid?";
        if (paymentRefId === null)
            throw new Error("The parameter 'paymentRefId' cannot be null.");
        else if (paymentRefId !== undefined)
            url_ += "paymentRefId=" + encodeURIComponent("" + paymentRefId) + "&";
        if (paymentDate === null)
            throw new Error("The parameter 'paymentDate' cannot be null.");
        else if (paymentDate !== undefined)
            url_ += "paymentDate=" + encodeURIComponent("" + paymentDate) + "&";
        if (marketplace === null)
            throw new Error("The parameter 'marketplace' cannot be null.");
        else if (marketplace !== undefined)
            url_ += "marketplace=" + encodeURIComponent("" + marketplace) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkMarkSaleAsPaid(_response);
        });
    }

    protected processBulkMarkSaleAsPaid(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkDeallocateCancelSalePreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkDeallocateCancelSalePreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeallocateCancelSalePreview(_response);
        });
    }

    protected processBulkDeallocateCancelSalePreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkDeallocateCancelSale(input: ValueTupleOfBulkEditPreviewAndNullableSaleCancellationReason, deallocateOnly: boolean | undefined, removeArtifacts: boolean | null | undefined, adminHold: boolean | null | undefined, keepAllocatedTickets: boolean | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkDeallocateCancelSale?";
        if (deallocateOnly === null)
            throw new Error("The parameter 'deallocateOnly' cannot be null.");
        else if (deallocateOnly !== undefined)
            url_ += "deallocateOnly=" + encodeURIComponent("" + deallocateOnly) + "&";
        if (removeArtifacts !== undefined && removeArtifacts !== null)
            url_ += "removeArtifacts=" + encodeURIComponent("" + removeArtifacts) + "&";
        if (adminHold !== undefined && adminHold !== null)
            url_ += "adminHold=" + encodeURIComponent("" + adminHold) + "&";
        if (keepAllocatedTickets !== undefined && keepAllocatedTickets !== null)
            url_ += "keepAllocatedTickets=" + encodeURIComponent("" + keepAllocatedTickets) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeallocateCancelSale(_response);
        });
    }

    protected processBulkDeallocateCancelSale(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateBarcodesPreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<{ [key: string]: TicketBarcodeResponse[]; }> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateBarcodesPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateBarcodesPreview(_response);
        });
    }

    protected processBulkUpdateBarcodesPreview(response: Response): Promise<{ [key: string]: TicketBarcodeResponse[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: TicketBarcodeResponse[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: TicketBarcodeResponse[]; }>(null as any);
    }

    bulkUpdateBarcodes(allBarcodes: { [key: string]: TicketBarcode[]; }, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateBarcodes?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(allBarcodes);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateBarcodes(_response);
        });
    }

    protected processBulkUpdateBarcodes(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkBackfillSalesFulfillerPreview(query: SalesFulfillerBackfillQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkBackfillSalesFulfillerPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkBackfillSalesFulfillerPreview(_response);
        });
    }

    protected processBulkBackfillSalesFulfillerPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkBackfillSalesFulfiller(input: ValueTupleOfBulkEditPreviewAndGuid, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkBackfillSalesFulfiller?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkBackfillSalesFulfiller(_response);
        });
    }

    protected processBulkBackfillSalesFulfiller(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }
}
export interface IBulkEditTicketGroupClient {

    cancelBackgroundTask(updateKey: string | undefined): Promise<boolean>;

    bulkDeleteTicketGroupPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkDeleteTicketGroup(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateDeliveryTypePreview(query: PurchaseOrderQuery, updateSalesOfListings: boolean | undefined): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateDeliveryType(input: ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority, updateSalesOfListings: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateSeatTraitsPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateSeatTraits(input: ValueTupleOfBulkEditPreviewAndIListOfListingNote, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, appendSeatTraits: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateFaceValuePreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateFaceValue(input: ValueTupleOfBulkEditPreviewAndDecimal, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkChangeEventPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkChangeEvent(preview: BulkEditPreview, posEventId: string | undefined, viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined, deallocateSales: boolean | null | undefined, reason: string | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkAdjustCostPreview(input: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateSeatingValidate(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateSeatingPreview(query: PurchaseOrderQuery, section: string | undefined, row: string | undefined, seatFrom: string | null | undefined, seatTo: string | null | undefined): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateSeating(input: ValueTupleOfBulkEditPreviewAndStringAndStringAndStringAndString, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, ticketSeatsJoined: string | null | undefined): Promise<BulkEditProgress>;
}

export class BulkEditTicketGroupClient extends PosClientBase implements IBulkEditTicketGroupClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    cancelBackgroundTask(updateKey: string | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/CancelBackgroundTask?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelBackgroundTask(_response);
        });
    }

    protected processCancelBackgroundTask(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    bulkDeleteTicketGroupPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkDeleteTicketGroupPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeleteTicketGroupPreview(_response);
        });
    }

    protected processBulkDeleteTicketGroupPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkDeleteTicketGroup(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkDeleteTicketGroup?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeleteTicketGroup(_response);
        });
    }

    protected processBulkDeleteTicketGroup(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateDeliveryTypePreview(query: PurchaseOrderQuery, updateSalesOfListings: boolean | undefined, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkUpdateDeliveryTypePreview?";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateDeliveryTypePreview(_response);
        });
    }

    protected processBulkUpdateDeliveryTypePreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateDeliveryType(input: ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority, updateSalesOfListings: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkUpdateDeliveryType?";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateDeliveryType(_response);
        });
    }

    protected processBulkUpdateDeliveryType(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateSeatTraitsPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkUpdateSeatTraitsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateSeatTraitsPreview(_response);
        });
    }

    protected processBulkUpdateSeatTraitsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateSeatTraits(input: ValueTupleOfBulkEditPreviewAndIListOfListingNote, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, appendSeatTraits: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkUpdateSeatTraits?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        if (appendSeatTraits !== undefined && appendSeatTraits !== null)
            url_ += "appendSeatTraits=" + encodeURIComponent("" + appendSeatTraits) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateSeatTraits(_response);
        });
    }

    protected processBulkUpdateSeatTraits(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateFaceValuePreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkUpdateFaceValuePreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateFaceValuePreview(_response);
        });
    }

    protected processBulkUpdateFaceValuePreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateFaceValue(input: ValueTupleOfBulkEditPreviewAndDecimal, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkUpdateFaceValue?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateFaceValue(_response);
        });
    }

    protected processBulkUpdateFaceValue(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkChangeEventPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkChangeEventPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkChangeEventPreview(_response);
        });
    }

    protected processBulkChangeEventPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkChangeEvent(preview: BulkEditPreview, posEventId: string | undefined, viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined, deallocateSales: boolean | null | undefined, reason: string | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkChangeEvent?";
        if (posEventId === null)
            throw new Error("The parameter 'posEventId' cannot be null.");
        else if (posEventId !== undefined)
            url_ += "posEventId=" + encodeURIComponent("" + posEventId) + "&";
        if (viagogoEventId !== undefined && viagogoEventId !== null)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (eventMappingId !== undefined && eventMappingId !== null)
            url_ += "eventMappingId=" + encodeURIComponent("" + eventMappingId) + "&";
        if (deallocateSales !== undefined && deallocateSales !== null)
            url_ += "deallocateSales=" + encodeURIComponent("" + deallocateSales) + "&";
        if (reason !== undefined && reason !== null)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkChangeEvent(_response);
        });
    }

    protected processBulkChangeEvent(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkAdjustCostPreview(input: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkAdjustCostPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkAdjustCostPreview(_response);
        });
    }

    protected processBulkAdjustCostPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateSeatingValidate(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkUpdateSeatingValidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateSeatingValidate(_response);
        });
    }

    protected processBulkUpdateSeatingValidate(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateSeatingPreview(query: PurchaseOrderQuery, section: string | undefined, row: string | undefined, seatFrom: string | null | undefined, seatTo: string | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkUpdateSeatingPreview?";
        if (section === null)
            throw new Error("The parameter 'section' cannot be null.");
        else if (section !== undefined)
            url_ += "section=" + encodeURIComponent("" + section) + "&";
        if (row === null)
            throw new Error("The parameter 'row' cannot be null.");
        else if (row !== undefined)
            url_ += "row=" + encodeURIComponent("" + row) + "&";
        if (seatFrom !== undefined && seatFrom !== null)
            url_ += "seatFrom=" + encodeURIComponent("" + seatFrom) + "&";
        if (seatTo !== undefined && seatTo !== null)
            url_ += "seatTo=" + encodeURIComponent("" + seatTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateSeatingPreview(_response);
        });
    }

    protected processBulkUpdateSeatingPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateSeating(input: ValueTupleOfBulkEditPreviewAndStringAndStringAndStringAndString, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, ticketSeatsJoined: string | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkUpdateSeating?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        if (ticketSeatsJoined !== undefined && ticketSeatsJoined !== null)
            url_ += "ticketSeatsJoined=" + encodeURIComponent("" + ticketSeatsJoined) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateSeating(_response);
        });
    }

    protected processBulkUpdateSeating(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }
}
